<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container full-width">
    <div class="page-title-section">
      <h1><mat-icon>shopping_cart</mat-icon> Pedidos</h1>
      <p class="page-subtitle">Acompanhe e gerencie os pedidos realizados</p>
    </div>

    <!-- Filters -->
    <div class="filter-section">
      <div class="filter-header">
        <mat-icon>tune</mat-icon>
        Filtros de Pesquisa
      </div>
      <div class="filter-body">
        <form [formGroup]="filterForm">
          <div class="filter-grid cols-3">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Código</mat-label>
            <input matInput type="text" formControlName="code" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>De</mat-label>
            <input matInput placeholder="dd/mm/yyyy" [matDatepicker]="dateFrom" autocomplete="off" formControlName="dateFrom" />
            <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
            <mat-datepicker #dateFrom></mat-datepicker>
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Até</mat-label>
            <input matInput placeholder="dd/mm/yyyy" [matDatepicker]="dateTo" autocomplete="off" formControlName="dateTo" />
            <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
            <mat-datepicker #dateTo></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="filter-grid cols-5" style="margin-top: 16px;">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Código Montadora (OE)</mat-label>
            <input matInput type="text" formControlName="automakerCode" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Montadora (OE)</mat-label>
            <input matInput type="text" formControlName="automakerTradeName" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Código Concessionária (CC)</mat-label>
            <input matInput type="text" formControlName="dealershipCode" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Concessionária (CC)</mat-label>
            <input matInput type="text" formControlName="dealershipTradeName" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>CNPJ Concessionária (CC)</mat-label>
            <input matInput type="text" formControlName="dealershipDocument" mask="AA.AAA.AAA/0000-00" />
          </mat-form-field>
        </div>
        <div class="filter-grid cols-4" style="margin-top: 16px;">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Código Pedido (OE)</mat-label>
            <input matInput type="text" formControlName="orderCode" />
          </mat-form-field>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Distribuidor Exclusivo (DE)</mat-label>
            <input matInput type="text" formControlName="distributorTradeName" />
          </mat-form-field>
          <app-select-form-field label="UF (DE)" [control]="state" [options]="states" [display]="stateCode"/>
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Status</mat-label>
            <mat-select placeholder="Selecione o status" formControlName="status">
              <mat-option>Todos</mat-option>
              <mat-option value="W">Em Aberto e Em Andamento</mat-option>
              <mat-option value="O">Em Aberto</mat-option>
              <mat-option value="P">Em Andamento</mat-option>
              <mat-option value="F">Finalizado</mat-option>
              <mat-option value="R">Recusado</mat-option>
              <mat-option value="C">Cancelado</mat-option>
            </mat-select>
          </mat-form-field>
          </div>
        </form>
      </div>
      <div class="filter-footer">
        <div class="filter-footer-left">
          <button mat-flat-button color="accent" class="mic-btn-icon-left" (click)="applyFilter()">
            <mat-icon>search</mat-icon><span>Buscar</span>
          </button>
          <button mat-stroked-button color="primary" class="mic-btn-icon-left" (click)="resetFilter()">
            <mat-icon>refresh</mat-icon><span>Limpar</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="table-section">
      <mic-table #table class="table-stripped" [config]="tableConfig" [fetcher]="fetcher">
        <ng-container *micCellTemplate="let item; name: 'codeCell'">
          <a (click)="redirectToDetails(item)">{{ item.codeOrder }}</a>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'codeOrderClientCell'">
          <a (click)="redirectToDetails(item)">{{ item.codeOrderClient }}</a>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'statusCell'">
          {{ item.status }}
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'actionsCell'">
          <button mat-icon-button color="primary" (click)="redirectToDetails(item)" matTooltip="Editar Pedido">
            <mat-icon>open_in_new</mat-icon>
          </button>
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'distributor'">
          @if (item.distributor) {
            <span>{{ item.distributor.company.tradeName }}</span>
          }
          @if (!item.distributor) {
            <span class="status-badge danger">Não encontrado</span>
          }
        </ng-container>
        <ng-container *micCellTemplate="let item; name: 'cancelCell'">
          <button [disabled]="isDisabled(item) || !item.distributor"
            mat-icon-button
            color="primary"
            matTooltipClass="big-tooltip"
            matTooltip="Cancelar Pedido"
            (click)="cancelItem(item)"
          >
            <mat-icon>cancel</mat-icon>
          </button>
        </ng-container>
      </mic-table>
    </div>
  </div>
</mic-spinner-overlay>

<mic-modal #modalConfirmCancel (result)="onModalConfirmCancelClosed($event)">
  <ng-template #contentModalConfirmCancel>
    <div>
      <p>Tem certeza que deseja cancelar o pedido {{selectedItem?.codeOrder}} da montatora {{selectedItem?.automaker?.company?.tradeName}}?</p>
    </div>
  </ng-template>
</mic-modal>